import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Drawer as MuiDrawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate, useLocation } from "react-router-dom";
import weblogo from "../assets/weblogo.png";
import { IoLogOut } from "react-icons/io5";
import ConfirmDialog from "./deleteModal";
import sidemenustroke from "../assets/sidemenudashboardiconstroke.png";
import sidemenufilled from "../assets/sidemenudashboardiconfilled.png";
import customerfilled from "../assets/customer filled.png";
import customerstroke from "../assets/customer fstroke.png";
import bookingstroke from "../assets/booking stroke.png";
import bookingsfilled from "../assets/booking filled.png";
import miantenancestroke from "../assets/maintanence stroke.png";
import maintenancefilled from "../assets/maintanance filled.png";
import vehiclefilled from "../assets/electric-scooter filled.png";
import vehiclestroke from "../assets/electric-scooter stokes.png";
import driverstroke from "../assets/driver-man stroke.png";
import companystroke from "../assets/Company stroke.png"
import companyfilled from "../assets/Company filled.png"
import driverfilled from "../assets/driver-man filled.png";
import incomestroke from "../assets/incomestroke.png";
import incomefilled from "../assets/incomefilled.png";
import fuelfilled from "../assets/fuel-gauge filled (2).png";
import fuelstroke from "../assets/fuel-gauge stroke.png";
import inventorystroke from "../assets/inventory-stroke.png";
import inventroyfilled from "../assets/inventroy filled.png";
import changepwfilled from "../assets/changepasswordfilled.png";
import changepwstroke from "../assets/changepasswordstroke.png";
import reminderfilled from "../assets/reminder-filled.png";
import reminderstroke from "../assets/reminder-stroke.png";
import { FaUser, FaRegUser } from "react-icons/fa";
import { getTenantConfigFromStorage, TENANT_CONFIG_STORAGE_KEY } from "../helpers/tenantConfig";

const drawerWidth = 240;

const MobileSidemenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = React.useState(false);
  const [menuOpenStates, setMenuOpenStates] = React.useState<{ [key: string]: boolean }>({});
  const [openDialog, setOpenDialog] = React.useState(false);

  const userString = localStorage.getItem("user");
  const user: any = userString ? JSON.parse(userString) : null;
  const role = user?.role;
  const tenantConfig = getTenantConfigFromStorage();
  const parentLabel = tenantConfig.labels.parent;
  const schoolLabel = tenantConfig.labels.school;
  const isCompanyTenant = tenantConfig.mode === "company";
  const companyListingPath = isCompanyTenant ? "/company-listing" : "/school-listing";
  const addCompanyPath = isCompanyTenant ? "/add-new-company" : "/add-new-school";
  const isSuperAdmin = role === "superAdmin";
  const isSchoolAdmin = role === "schoolAdmin";
  const canViewModules = isSuperAdmin || role === "admin" || isSchoolAdmin;
  const canEditModules = isSuperAdmin || role === "admin";

  // ✅ icons same as Desktop Sidebar
  const menuItems: any[] = [
    {
      text: "Dashboard",
      path: "/dashboard",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/dashboard" ? sidemenufilled : sidemenustroke} alt="Dashboard" style={{ width: 24, height: 24 }} />
      ),
    },
    isSuperAdmin && {
      text: "Tenant",
      path: "/tenant-list",
      renderIcon: (pathname: string) =>
        pathname.startsWith("/tenant") || pathname.startsWith("/create-tenant") ? <FaUser size={20} /> : <FaRegUser size={20} />,
      children: [{ text: "Tenant List", path: "/tenant-list" }, { text: "Create Tenant", path: "/create-tenant" }],
    },
    canViewModules && {
      text: "Vehicle",
      path: "/vehicle-list",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/vehicle-list" ? vehiclefilled : vehiclestroke} alt="Vehicle" style={{ width: 24, height: 24 }} />
      ),
      children: [
        { text: "Vehicle List", path: "/vehicle-list" },
        canEditModules && { text: "Add Vehicle", path: "/add-vehicle" },
      ].filter(Boolean),
    },
    canViewModules && {
      text: schoolLabel,
      path: companyListingPath,
      renderIcon: (pathname: string) => (
        <img src={pathname === companyListingPath ? companyfilled : companystroke} alt="School" style={{ width: 24, height: 24 }} />
      ),
      children: [
        { text: `${schoolLabel} List`, path: companyListingPath },
        canEditModules && { text: `Add ${schoolLabel}`, path: addCompanyPath },
      ].filter(Boolean),
    },
    
    canViewModules && {
      text: "Driver",
      path: "/driver-list",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/driver-list" ? driverfilled : driverstroke} alt="Driver" style={{ width: 24, height: 24 }} />
      ),
      children: [
        { text: "Driver List", path: "/driver-list" },
        canEditModules && { text: "Add Driver", path: "/add-driver" },
      ].filter(Boolean),
    },
    canViewModules && {
      text: "Booking",
      path: "/booking-list",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/booking-list" ? bookingsfilled : bookingstroke} alt="Booking" style={{ width: 24, height: 24 }} />
      ),
      children: [
        { text: "Booking List", path: "/booking-list" },
        { text: "See All Van", path: "/all-van" },
        canEditModules && { text: "Add Booking", path: "/add-booking" },
      ].filter(Boolean),
    },
    canViewModules && {
      text: `${parentLabel}s`,
      path: "/parent-list",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/parent-list" ? customerfilled : customerstroke} alt="Parents" style={{ width: 24, height: 24 }} />
      ),
      children: [
        { text: `${parentLabel} Management`, path: "/parent-list" },
        canEditModules && { text: `Add ${parentLabel}`, path: "/add-parent" },
      ].filter(Boolean),
    },
    canEditModules && {
      text: "User",
      path: "/user",
      renderIcon: (pathname: string) =>
        pathname.startsWith("/user") ? <FaUser size={20} /> : <FaRegUser size={20} />,
      children: [
        { text: "User List", path: "/user-list" },
        { text: "Add User", path: "/addUser" },
      ],
    },
    canViewModules && !isSchoolAdmin && {
      text: "Change Password",
      path: "/change-password",
      renderIcon: (pathname: string) => (
        <img src={pathname === "/change-password" ? changepwfilled : changepwstroke} alt="Change Password" style={{ width: 24, height: 24 }} />
      ),
    },
  ].filter(Boolean);

  const toggleMenu = (text: string) =>
    setMenuOpenStates((prev) => ({ ...prev, [text]: !prev[text] }));

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem(TENANT_CONFIG_STORAGE_KEY);
    navigate("/login");
  };

  return (
    <Box>
      {/* Mobile Top Bar */}
      <Box
        sx={{
          height: 60,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          backgroundColor: "rgb(7, 105, 180)",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          position: "sticky",
          top: 0,
          zIndex: 1200,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src={weblogo} style={{ height: 55 }} />
          <span style={{ fontWeight: "bold", fontSize: "18px", color: "white" }}>Carfleet</span>
        </Box>
        <IconButton onClick={() => setOpen(true)} sx={{ color: "white" }}>
          <MenuIcon />
        </IconButton>
      </Box>

      {/* Drawer */}
      <MuiDrawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            backgroundColor: "white",
            color: "black",
          },
        }}
      >
        <Divider />
        <List>
          {menuItems.map((item) => {
            if (!item) return null;
            const hasChildren = item.children && item.children.length > 0;
            const isSubmenuOpen = menuOpenStates[item.text];

            return (
              <React.Fragment key={item.text}>
                <ListItem disablePadding style={{flexDirection:"column",alignItems:"start"}}>
                  <ListItemButton
                    onClick={() => {
                      if (hasChildren) toggleMenu(item.text);
                      else {
                        navigate(item.path);
                        setOpen(false);
                      }
                    }}
                    sx={{ color: "black" }}
                  >
                    <ListItemIcon sx={{ color: "black" }}>
                      {item.renderIcon ? item.renderIcon(location.pathname) : item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                    {hasChildren && (isSubmenuOpen ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {hasChildren && (
                    <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.children.map((child: any) => (
                          <ListItemButton
                            key={child.text}
                            sx={{ pl: 4, color: "black" }}
                            onClick={() => {
                              navigate(child.path);
                              setOpen(false);
                            }}
                          >
                            <ListItemText primary={child.text} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </ListItem>
              </React.Fragment>
            );
          })}
        </List>

        <Divider />

        <Box sx={{ p: 2 }}>
          <button
            onClick={() => setOpenDialog(true)}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              padding: "8px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Logout <IoLogOut />
          </button>
        </Box>
      </MuiDrawer>

      <ConfirmDialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  onConfirm={handleLogout}
  variant="logout"
/>
    </Box>
  );
};

export default MobileSidemenu;
